import { Copy, Tooltip, t } from '@stokr/components-library'
import { ExternalLinkIcon } from 'components/ui/icons'
import { Section } from 'components/sto/Section'
import { figureTooltip } from 'components/ui/investmentCard/InvestmentCard'
import { useKeyInformation, type KeyInformationRow } from 'hooks/sto/useKeyInformation'
import {
  Group,
  Groups,
  GroupTitle,
  Label,
  LinkText,
  Row,
  TooltipIcon,
  Value,
  ValueGroup,
  ValueLink,
} from './KeyInformation.styles'
import { useStoTrack } from 'hooks/sto/useStoTracking'

const RowValue = ({ row }: { row: KeyInformationRow }) => {
  const trackSto = useStoTrack()
  return row.href ? (
    <ValueLink
      href={row.href}
      target="_blank"
      rel="noopener noreferrer"
      title={row.href}
      data-cy={`sto-key-information-link-${row.key}`}
      onClick={() => trackSto('sto_key_info_link_clicked', { field: row.key })}>
      <LinkText>{row.value}</LinkText>
      <ExternalLinkIcon width={14} height={14} aria-hidden="true" />
    </ValueLink>
  ) : (
    <Value>{row.value}</Value>
  )
}

export const KeyInformation = () => {
  const state = useKeyInformation()

  return (
    <Section
      anchor="key-information"
      title={<Copy id="stoPage.keyInformation.title" />}
      state={state}
      skeletonRows={6}
      elevated>
      {(groups) => (
        <Groups>
          {groups.map((group) => (
            <Group key={group.key}>
              {group.label && <GroupTitle>{group.label}</GroupTitle>}
              {group.rows.map((row) => (
                <Row key={row.key}>
                  <Label>{row.label}</Label>
                  <ValueGroup>
                    <RowValue row={row} />
                    {row.tooltip && (
                      <Tooltip placement="top" content={figureTooltip(row.tooltip, row)}>
                        <TooltipIcon role="button" tabIndex={0} aria-label={t('stoPage.keyInformation.moreInfo')} />
                      </Tooltip>
                    )}
                  </ValueGroup>
                </Row>
              ))}
            </Group>
          ))}
        </Groups>
      )}
    </Section>
  )
}
